export type PhoneConfig = {
  display: string
  href: string
}

export type GeoResponse = {
  city?: string | null
  settlement?: string | null
  area?: string | null
  region?: string | null
  ip?: string | null
}

const DEFAULT_PHONE_HREF = '+78124081913'
const DEFAULT_EMAIL = 'sales@engvar.ru'

export function showContacts(): void {
  document.querySelectorAll<HTMLElement>('.dynamic-contacts').forEach((el) => {
    el.style.visibility = 'visible'
  })
}

export function applyPhoneAndEmail(
  phone: PhoneConfig,
  email: string,
  geo: GeoResponse,
): void {
  const place = geo.city || geo.settlement || geo.area || geo.region || 'Ваш регион'
  const phoneLabel = `${place}: ${phone.display}`

  document.querySelectorAll<HTMLElement>('.roistat-phone').forEach((el) => {
    if (el.tagName.toLowerCase() === 'a') {
      el.setAttribute('href', `tel:${phone.href}`)
    }
    el.textContent = phoneLabel
  })

  document.querySelectorAll<HTMLAnchorElement>('a[href^="tel:"]').forEach((link) => {
    const href = link.getAttribute('href') || ''
    const normalizedHref = href.replace(/[^\d+]/g, '')

    if (normalizedHref === DEFAULT_PHONE_HREF) {
      link.setAttribute('href', `tel:${phone.href}`)
      link.textContent = phoneLabel
    }
  })

  document.querySelectorAll<HTMLAnchorElement>('.dynamic-email').forEach((link) => {
    link.setAttribute('href', `mailto:${email}`)
    link.textContent = email
  })

  document.querySelectorAll<HTMLAnchorElement>('a[href^="mailto:"]').forEach((link) => {
    const href = (link.getAttribute('href') || '').toLowerCase()

    if (href === `mailto:${DEFAULT_EMAIL.toLowerCase()}`) {
      link.setAttribute('href', `mailto:${email}`)
      link.textContent = email
    }
  })

  const hasPhone = document.querySelector('.roistat-phone')
  const hasEmail = document.querySelector('.dynamic-email')

  if (hasPhone && hasEmail) {
    showContacts()
  }
}
